import React from 'react'

import { Box, withCitrusTheme } from '@gousto-internal/citrus-react'
import { useSelector } from 'react-redux'

import { RecipeImage as Image, MenuRecipeImage } from '@library/menu-service'

import { getBrowserType } from 'selectors/browser'
import { getFeaturedImage, getRangeImages } from 'utils/image'

import { DetailCarousel } from '../Carousel'
import { DetailImage } from '../DetailImage'

type RecipeImageProps = {
  title: string
  images: {
    partial?: Image[]
    full?: MenuRecipeImage[]
  }
}

const ImageContainer = withCitrusTheme(Box, (theme) => ({
  marginLeft: `-${theme.spacing(4)}px`,
  marginTop: `-${theme.spacing(4)}px`,
  width: `calc(100% + 2*${theme.spacing(4)}px)`,
  [`@media (min-width: ${theme.tokens.breakpoints[0]})`]: {
    marginLeft: `-${theme.spacing(6)}px`,
    marginTop: `-${theme.spacing(6)}px`,
    width: `calc(100% + 2*${theme.spacing(6)}px)`,
  },
}))

export const RecipeImage = ({ images, title }: RecipeImageProps) => {
  const { partial: partialImages, full: fullImages } = images
  const browserType = useSelector(getBrowserType)

  const featuredImage = getFeaturedImage(partialImages, 'standard', browserType)
  const rangeImages = getRangeImages(fullImages)

  return (
    <ImageContainer>
      {rangeImages.length > 0 ? (
        <DetailCarousel images={rangeImages} />
      ) : (
        <DetailImage media={featuredImage} title={title} />
      )}
    </ImageContainer>
  )
}
